import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { flex } from '@flipster/styled-system/patterns';

import { BunjaDetails } from './bunja-details';
import { BunjaList } from './bunja-list';
import { SelectedBunjaIdContext, dagDevtoolsBunja } from './state';

export const Dag = () => {
  const { selectedBunjaIdAtom } = useBunja(dagDevtoolsBunja);
  const selectedBunjaId = useAtomValue(selectedBunjaIdAtom);

  return (
    <div
      className={flex({
        direction: 'row',
        minH: '100%',
        maxH: '100%',
        flex: 1,
        rounded: 4,
        overflow: 'hidden',
        bgColor: 'background.default.level-0',
        gap: 0,
      })}
    >
      <BunjaList />
      {selectedBunjaId && (
        <SelectedBunjaIdContext value={selectedBunjaId}>
          <BunjaDetails key={selectedBunjaId} />
        </SelectedBunjaIdContext>
      )}
    </div>
  );
};
